import { Grid } from '@mui/material';

export interface StatsProps {
  matchStats?: any[];
  matchId?: number;
  playerId?: number;
}

export const MatchPlayerStats = ({
  matchStats,
  matchId,
  playerId,
}: StatsProps) => {
  if (!matchStats?.length) return null;

  const match = matchStats.find((match: any) => match?.MatchFeedId === matchId);
  if (!match) return null;

  const homeTeamStats = match.MatchStats.find(
    (stat: any) => stat.TeamFeedId === match.HomeTeamFeedId
  );
  const awayTeamStats = match.MatchStats.find(
    (stat: any) => stat.TeamFeedId === match.AwayTeamFeedId
  );
  if (!homeTeamStats || !awayTeamStats) return null;

  const player = [...homeTeamStats.Players, ...awayTeamStats.Players].find(
    (player) => player.PlayerFeedId === playerId
  );
  if (!player) return null;

  return (
    <Grid container>
      <Grid item xs={12} sx={{ textAlign: 'center', fontSize: 10 }}>
        Player Match Stats
      </Grid>
      <Grid item xs={6} sx={{ textAlign: 'left' }}>
        Goals:
        <br />
        Assists:
        <br />
        SOG:
        <br />
        Saves:
        <br />
        Hits:
        <br />
        Assists:
        <br />
      </Grid>
      <Grid item xs={6} sx={{ textAlign: 'right' }}>
        {player?.goals === null ? '--' : player?.goals}
        <br />
        {player?.assists === null ? '--' : player?.assists}
        <br />
        {player?.shots_on_goal === null ? '--' : player?.shots_on_goal}
        <br />
        {player?.saves === null ? '--' : player?.saves}
        <br />
        {player?.hits === null ? '--' : player?.hits}
        <br />
        {player?.assists === null ? '--' : player?.assists}
        <br />
      </Grid>
    </Grid>
  );
};
